// src/lib/api.js
// Authenticated fetch wrapper — attaches the Supabase session token to API calls.

import { supabase } from './supabase'

/**
 * Authenticated fetch wrapper — attaches the Supabase session token to API calls.
 * @param {string} url
 * @param {RequestInit} [options]
 * @returns {Promise<Response>}
 */
export async function authFetch(url, options = {}) {
  const { data: { session } } = await supabase.auth.getSession()

  const headers = /** @type {Record<string, string>} */ ({
    ...(options.headers instanceof Headers
      ? Object.fromEntries(options.headers.entries())
      : options.headers ?? {}),
  })

  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`
  }

  return fetch(url, { ...options, headers })
}
